import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 900,
      md: 1150,
      lg: 1200,
      xl: 1536
    }
  }
});
